import React from 'react';
import ReportFrame from '../ReportFrame';

export default class VoidAndReissued extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const reportParams = {};
    return (
      <div className='contentwrapper bg-white'>
        <ReportFrame
          reportName='Void and Reissued'
          reportParams={reportParams}
          id='voidandreissued'
          name='voidandreissued'
          title='Void and Reissued'
        />
      </div>
    );
  }
}
